import { useEffect, useState } from 'react'
import { pythonApiFetch } from '../mechanical-tests/api'

interface MechProjectDetail {
  mech_counts?: {
    reports?: number
  }
}

export function useProjectMechanicalReports(
  projectId: string | undefined,
  enabled: boolean
): {
  hasMechanicalReports: boolean
  loading: boolean
} {
  const [hasMechanicalReports, setHasMechanicalReports] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!projectId || !enabled) {
      setHasMechanicalReports(false)
      setLoading(false)
      return
    }

    let cancelled = false

    ;(async () => {
      setLoading(true)
      try {
        const detail = await pythonApiFetch<MechProjectDetail>(
          `/api/projects/${encodeURIComponent(projectId)}`
        )
        if (!cancelled) {
          setHasMechanicalReports((detail.mech_counts?.reports ?? 0) > 0)
        }
      } catch {
        if (!cancelled) setHasMechanicalReports(false)
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()

    return () => {
      cancelled = true
    }
  }, [projectId, enabled])

  return { hasMechanicalReports, loading }
}
